(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var sectionId = "{{ section.id }}";
  var mapElement = document.getElementById("map-" + sectionId);
  var searchInput = document.getElementById("store-search-" + sectionId);
  var nearMeButton = document.getElementById("near-me-btn-" + sectionId);
  var storeCards = document.querySelectorAll("#store-list-" + sectionId + " .store-card");
  var map, markers = [];

  function initMap() {
    var center = { lat: 37.7749, lng: -122.4194 }; // Default center
    map = new google.maps.Map(mapElement, { zoom: 4, center: center });

    // Create markers
    storeCards.forEach(function(card) {
      var lat = parseFloat(card.dataset.lat);
      var lng = parseFloat(card.dataset.lng);
      if (!isNaN(lat) && !isNaN(lng)) {
        var marker = new google.maps.Marker({
          position: { lat: lat, lng: lng },
          map: map,
          title: card.dataset.name
        });
        markers.push({ marker: marker, card: card });
      }
    });
  }

  // Search filter
  searchInput.addEventListener("input", function() {
    var query = this.value.toLowerCase();
    markers.forEach(function(item) {
      var name = item.card.dataset.name.toLowerCase();
      var address = item.card.dataset.address.toLowerCase();
      var match = name.includes(query) || address.includes(query);
      item.card.style.display = match ? "block" : "none";
      item.marker.setVisible(match);
    });
  });

  // Near Me
  nearMeButton.addEventListener("click", function() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        var userLatLng = { lat: position.coords.latitude, lng: position.coords.longitude };
        map.setCenter(userLatLng);
        map.setZoom(10);

        // Sort by distance
        var distances = [];
        markers.forEach(function(item) {
          var lat = parseFloat(item.card.dataset.lat);
          var lng = parseFloat(item.card.dataset.lng);
          var distance = Math.sqrt(Math.pow(lat - userLatLng.lat, 2) + Math.pow(lng - userLatLng.lng, 2));
          distances.push({ card: item.card, distance: distance });
        });
        distances.sort(function(a, b) { return a.distance - b.distance; });

        var container = document.getElementById("store-list-" + sectionId);
        distances.forEach(function(item) {
          container.appendChild(item.card);
        });
      });
    } else {
      alert("Geolocation not supported.");
    }
  });

  // Load Google Maps
  if ("{{ section.settings.google_maps_api_key }}") {
    var script = document.createElement("script");
    script.src = "https://maps.googleapis.com/maps/api/js?key={{ section.settings.google_maps_api_key }}&callback=initMap";
    script.async = true;
    document.head.appendChild(script);
    window.initMap = initMap;
  } else {
    mapElement.innerHTML = "<p>Please provide a Google Maps API Key in settings.</p>";
  }
});

  } catch(e) { console.error(e); }
})();
})();
